<div class="login-rehlte-pop">
<div class="modal-header">
  <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="cancel()">
  </button>
  <h5 class="modal-title" *ngIf="tabIndex === 1">Sign in</h5>
  <h5 class="modal-title" *ngIf="tabIndex === 2">Create New Account</h5>
  <h5 class="modal-title" *ngIf="tabIndex === 3">{{ modalTitle }}</h5>
  <h5 class="modal-title" *ngIf="tabIndex === 4">You're All Set</h5>
  <h5 class="modal-title" *ngIf="tabIndex === 5">You're All Set</h5>
</div>
<div class="modal-body">  

  <!-- remaining issue -->
  <app-login-form *ngIf="tabIndex === 1" class="login-with-po"  (childButtonEventLogin)="receivedMessageHandler($event)" (childButtonEventReset)="receivedMessageHandler($event)" (clickHandlerSuccessful)="receivedMessageHandler($event)" (closeModal)="cancel()"></app-login-form>
  <app-create-new-account *ngIf="tabIndex === 2" class="login-with-po" (childButtonEvent)="receivedMessageHandler($event)" (clickHandlerSuccessful)="receivedMessageHandler($event)" (closeModal)="cancel()"></app-create-new-account>
  <app-reset-password *ngIf="tabIndex === 3" class="login-with-po" (childButtonEventNewPassword)="receivedMessageHandlerReset($event)" (childButtonEventEnterOtp)="receivedMessageHandlerReset($event)" (childButtonEventOtpSent)="receivedMessageHandlerReset($event)" (childButtonEventLogin)="receivedMessageHandler($event)" (closeModal)="cancel()"></app-reset-password>
  <app-login-successful *ngIf="tabIndex === 4" class="login-with-po" (closeModal)="cancel()"></app-login-successful>  
  <app-signup-successful *ngIf="tabIndex === 5" class="login-with-po" (closeModal)="cancel()"></app-signup-successful>

</div>
</div>